import { render } from "./ourMobileApplication.vue?vue&type=template&id=61d04b0e&scoped=true"
import script from "./ourMobileApplication.vue?vue&type=script&lang=js"
export * from "./ourMobileApplication.vue?vue&type=script&lang=js"

import "./ourMobileApplication.vue?vue&type=style&index=0&id=61d04b0e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d04b0e"]])

export default __exports__